import * as Sentry from '@sentry/react';
import { env } from '../configs/EnvironmentConfig';
import { history } from '../broserHistory';
import { Integrations } from '@sentry/tracing';
import { Member, User } from '@quick/client';

Sentry.init({
  dsn: env.REACT_APP_SENTRY_DSN,
  environment: env.REACT_APP_ENV,
  debug: env.REACT_APP_ENV !== 'prod',
  integrations: [
    new Integrations.BrowserTracing({
      // Can also use reactRouterV3Instrumentation or reactRouterV4Instrumentation
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: parseFloat(env.REACT_APP_SENTRY_TRACING_RATE),
});

export const identifySentry = (user: User, member?: Member) => {
  Sentry.setUser({
    id: user.userId.toString(),
    username: user.email,
    email: user.email,
    memberId: member?.memberId,
    memberName: member?.name,
    memberEmail: member?.email,
    communityId: member?.communityId,
  });
};

export const resetSentry = () => {
  Sentry.setUser(null);
};
